import Image from 'next/image';
import Link from 'next/link';
import FireIcon from '@/public/icons/collection/fire.svg';
import {
  shouldShowBoxingDayTheme,
  shouldShowChristmasTheme,
  shouldShowCyberWeek,
  shouldShowHolidays,
} from '@/lib/holidays';
import i18n from '@/settings/i18n';

const t = i18n.init('shared');

const Deals = () => {
  const generateLabel = () => {
    if (shouldShowBoxingDayTheme) {
      return t`Boxing Day Deals`;
    }

    if (shouldShowChristmasTheme) {
      return t`Holiday Deals`;
    }

    if (shouldShowCyberWeek) {
      return t`Cyber Week Deals`;
    }

    if (shouldShowHolidays) {
      return t`Holiday Deals`;
    }

    return t`Deals`;
  };

  const label = generateLabel();

  return (
    <li>
      <Link
        href="/collections/hot-deals"
        className="flex h-full items-center justify-center gap-1.5 font-medium outline-none"
      >
        <span
          // eslint-disable-next-line tailwindcss/no-custom-classname
          className="fancy-underline"
        >
          {label}{' '}
        </span>
        <div className="h-4 w-4">
          <Image priority src={FireIcon} alt="Deal" />
        </div>
      </Link>
    </li>
  );
};

export default Deals;
